export enum ButtonState {
  Enabled = 'enabled',
  Hovered = 'hovered',
  Pressed = 'pressed',
  Disabled = 'disabled',
  Loading = 'loading',
}
